import { FC } from 'react'
import Link from 'next/link'
import Text from 'components/base/Text'
import Avatar from 'components/generic/Avatar'
import { Box } from '@careguide/theme'
import { getListingPath } from 'utils/routeUtils'
import { CardContainer, SiteBanner } from './ProfileCard.style'

export type FeatureProps = {
  sisterProfile: boolean
}

export type ProfileCardProps = {
  profile: TODO
  features?: FeatureProps
}

const DEFAULT_FEATURES: FeatureProps = {
  sisterProfile: false,
}

const ProfileCard: FC<ProfileCardProps> = ({ profile, features = DEFAULT_FEATURES }) => {
  const avatarImageUrl = profile?.avatar?.mediumUrl
  const avatarAltText = profile?.avatar?.name
  const fullName = profile?.user?.fullName
  const domain = profile?.site?.domain
  const listingPath = getListingPath({
    path: profile?.path,
    domain: features.sisterProfile ? domain : null,
  })
  const badgeImgPath = profile?.site?.getStarted?.badge?.imageUrl
  return (
    <Link href={listingPath} passHref>
      <a
        css={`
          display: block;
          text-decoration: none;
        `}
      >
        <CardContainer features={features} role='listitem'>
          {features.sisterProfile && (
            <SiteBanner fontSize='0' badge={badgeImgPath}>
              {profile?.site?.name}
            </SiteBanner>
          )}
          <Box display='flex'>
            {avatarImageUrl && (
              <Avatar
                width='32px'
                height='32px'
                url={avatarImageUrl}
                altText={avatarAltText}
                aria-hidden
              />
            )}
            <Box ml='2'>
              <Text as='h4' m='0' fontWeight='bold'>
                {fullName}
              </Text>
              <Text fontSize='0' m='0'>
                {profile?.name}
              </Text>
            </Box>
          </Box>
        </CardContainer>
      </a>
    </Link>
  )
}

export default ProfileCard
